import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import EnquiriesTab from './components/EnquiriesTab';
import SpeakersTab from './components/SpeakersTab';
import PageContentTab from './components/PageContentTab';
import SponsorsTab from './components/SponsorsTab';
import TrainingsTab from './components/TrainingsTab';
import CFPTab from './components/CFPTab';
import CTFTab from './components/CTFTab';
import ScheduleTab from './components/ScheduleTab';

export default function AdminDashboard() {
    const [activeTab, setActiveTab] = useState('enquiries');
    const navigate = useNavigate();

    const handleLogout = async () => {
        await supabase.auth.signOut();
        navigate('/admin/login');
    };

    return (
        <section className="admin-dashboard-section" style={{ minHeight: '100vh', padding: '80px 0', background: '#0d0010' }}>
            <div className="container">
                <div className="d-flex justify-content-between align-items-center mb-5 border-bottom border-secondary pb-3">
                    <h2 className="text-white" style={{ fontFamily: 'var(--eventflow-font)', fontWeight: 800 }}>Admin Dashboard</h2>
                    <button onClick={handleLogout} className="btn btn-outline-light px-4 py-2" style={{ borderRadius: '8px' }}>
                        Logout
                    </button>
                </div>

                {/* Tabs Navigation */}
                <ul className="nav nav-pills mb-4" style={{ gap: '10px' }}>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'enquiries' ? 'active' : 'text-white'}`}
                            style={{ 
                                background: activeTab === 'enquiries' ? 'var(--eventflow-primary)' : 'rgba(255,255,255,0.05)',
                                borderRadius: '8px',
                                fontWeight: '600'
                            }}
                            onClick={() => setActiveTab('enquiries')}
                        >
                            Enquiries
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'speakers' ? 'active' : 'text-white'}`}
                            style={{ 
                                background: activeTab === 'speakers' ? 'var(--eventflow-primary)' : 'rgba(255,255,255,0.05)',
                                borderRadius: '8px',
                                fontWeight: '600'
                            }}
                            onClick={() => setActiveTab('speakers')}
                        >
                            Speakers
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'pageContent' ? 'active' : 'text-white'}`}
                            style={{ 
                                background: activeTab === 'pageContent' ? 'var(--eventflow-primary)' : 'rgba(255,255,255,0.05)',
                                borderRadius: '8px',
                                fontWeight: '600'
                            }}
                            onClick={() => setActiveTab('pageContent')}
                        >
                            Page Content
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'sponsors' ? 'active' : 'text-white'}`}
                            onClick={() => setActiveTab('sponsors')}
                            style={activeTab === 'sponsors' ? { background: 'var(--eventflow-primary)', borderRadius: '8px', fontWeight: '600' } : { border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontWeight: '600' }}
                        >
                            <i className="fas fa-handshake me-2"></i> Sponsors
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'cfp' ? 'active' : 'text-white'}`}
                            onClick={() => setActiveTab('cfp')}
                            style={activeTab === 'cfp' ? { background: 'var(--eventflow-primary)', borderRadius: '8px', fontWeight: '600' } : { border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontWeight: '600' }}
                        >
                            CFP
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'ctf' ? 'active' : 'text-white'}`}
                            onClick={() => setActiveTab('ctf')}
                            style={activeTab === 'ctf' ? { background: 'var(--eventflow-primary)', borderRadius: '8px', fontWeight: '600' } : { border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontWeight: '600' }}
                        >
                            CTF
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'schedule' ? 'active' : 'text-white'}`}
                            onClick={() => setActiveTab('schedule')}
                            style={activeTab === 'schedule' ? { background: 'var(--eventflow-primary)', borderRadius: '8px', fontWeight: '600' } : { border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontWeight: '600' }}
                        >
                            <i className="fa fa-calendar-alt me-2"></i> Schedule
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${activeTab === 'trainings' ? 'active' : 'text-white'}`}
                            onClick={() => setActiveTab('trainings')}
                            style={activeTab === 'trainings' ? { background: 'var(--eventflow-primary)', borderRadius: '8px', fontWeight: '600' } : { border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontWeight: '600' }}
                        >
                            <i className="fas fa-chalkboard-teacher me-2"></i> Trainings
                        </button>
                    </li>
                </ul>

                {/* Tab Content */}
                <div className="tab-content mt-4">
                    {activeTab === 'enquiries' && <EnquiriesTab />}
                    {activeTab === 'speakers' && <SpeakersTab />}
                    {activeTab === 'pageContent' && <PageContentTab />}
                    {activeTab === 'schedule' && <ScheduleTab />}
                    {activeTab === 'sponsors' && <SponsorsTab />}
                    {activeTab === 'cfp' && <CFPTab />}
                    {activeTab === 'ctf' && <CTFTab />}
                    {activeTab === 'trainings' && <TrainingsTab />}
                </div>
            </div>
        </section>
    );
}
